import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import { useEffect, useState } from 'react';
import { fetchPodcastReleaseDate } from '../../redux/slices/podcastsSlice';
import { PlatformsAndSocials } from '../PlatformsAndSocials/PlatformsAndSocials';
import { GenreList } from '../GenreList/GenreList';
import { FavoriteButton } from '../FavoriteButton/FavoriteButton';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import { capitalize } from 'lodash';

export const PodcastInfo = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    currentPodcast,
    genres,
    activePlatform,
    topPodcasts: { data },
  } = useSelector((state) => state.podcasts);
  const [releaseDate, setReleaseDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day} ${year}`;
  };

  useEffect(() => {
    if (!currentPodcast) return;
    setIsLoading(true);

    dispatch(fetchPodcastReleaseDate({ feedUrl: currentPodcast.feedUrl })).then((response) => {
      setReleaseDate(response.payload);
      setIsLoading(false);
    });
  }, [currentPodcast, dispatch]);

  if (!currentPodcast) return null;

  return (
    <Box className={classes.podcastInfo}>
      <Box className={classes.podcastInfoWrapper}>
        <img src={currentPodcast.artworkUrl60} alt={currentPodcast.name} className={classes.podcastImage} />
        <Box className={classes.podcastDetailsWrapper}>
          <Box className={classes.podcastTitle}>
            <Box className={classes.podcastName}>
              <span>
                {currentPodcast.collectionName}
                <Box sx={{ display: 'inline' }}>
                  <FavoriteButton />
                  <PlatformsAndSocials />
                </Box>
              </span>
            </Box>
          </Box>
          <Box className={classes.podcastDetails}>
            <Typography className={`${classes.podcastInfoText}`}>
              Released on {isLoading ? <LoadingDots /> : releaseDate ? formatDate(releaseDate) : '...'}
            </Typography>
            <Typography className={`${classes.podcastEpisodes}`}>
              {currentPodcast.trackCount} episodes
            </Typography>

            <Box className={classes.podcastCategoriesWrapper}>
              {genres.length > 0 && data.length > 0 && (
                <Typography className={`${classes.podcastCategories}`}>
                  charting on {capitalize(activePlatform)} in: <GenreList />
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
